var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","tag":"section"}},[_c('base-material-table',{ref:"table",attrs:{"outlined":"","item":_vm.item},on:{"on-add":_vm.add}}),_c('add-view',{attrs:{"item":_vm.addModal},on:{"on-load-data":_vm.loadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }